// extracted by mini-css-extract-plugin
module.exports = {"makerGreen":"#385461","makerLightGrey":"#e8e7e6","editor":"editor_editor__1nHIK","title":"editor_title__21REx"};